import { sendPersonalDataConsent } from '~/api/user'

const usePersonalDataConsent = () => {

  function sendUserConsent(formOriginCode) {
    sendPersonalDataConsent(formOriginCode)
      .then((result) => {
        if (result?.error) {
          console.error(`Проблема с согласием на обработку ПД: ${result.error}`)
        }
      })
      .catch((error) => {
        console.error(error)
      }) 
  }

  return {
    sendUserConsent
  }
}

export default usePersonalDataConsent